import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selector"]
  static values = {
    activityId: Number
  }

  renderActivityAdminUsersTable() {
    this.fetchActivityAdminUsers()
  }

  fetchActivityAdminUsers() {
    const url = `/admin/activities/${this.activityIdValue}/activity_admin_user_managements/selected_admin_users`
    const selectedAdminUserIds = this.selectorTarget.tomselect.items
    const params = new URLSearchParams
    selectedAdminUserIds.forEach(id => {
      params.append('admin_user_ids[]', id)
    })
    const urlWithParams = `${url}?${params}`

    fetch(urlWithParams)
      .then(response => response.json())
      .then(data => {
        this.buildActivityAdminUsersTable(data)
      })
      .catch(error => {
        console.error('Error:', error)
      })
  }

  buildActivityAdminUsersTable(data) {
    // 建立表格 HTML
    const tableHTML = `
      <admin-tables-general class="block">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500">
          <thead class="text-gray-700 uppercase border-gray-200 border-b-1">
            <tr>
                <th class="px-6 py-4" scope="col">帳號</th>
                <th class="px-6 py-4" scope="col">顯示名稱</th>
                <th class="px-6 py-4" scope="col">角色</th>
                <th class="px-6 py-4" scope="col">部門</th>
                <th class="px-6 py-4" scope="col">通知信</th>
            </tr>
          </thead>
          <tbody class="[&>:last-child]:border-b-1">
            ${data.map(user => `
              <tr class="bg-white border-b border-gray-200 hover:bg-gray-50">
                <td class="px-6 py-4 font-medium text-gray-900">
                  <a class="hover:underline" href="/admin/admin_users/${user.id}">${user.account}</a>
                </td>
                <td class="px-6 py-4">
                  ${user.name}
                </td>
                <td class="px-6 py-4">
                  ${user.admin_role_name}
                </td>
                <td class="px-6 py-4">
                  ${user.department}
                </td>
                <td class="px-6 py-4">
                  ${user.email_notify ? 'v' : ''}
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </admin-tables-general>
    `
    
    // 找到目標元素並更新內容
    const targetElement = document.getElementById('activity_admin_users_table')
    if (targetElement) { targetElement.innerHTML = tableHTML }
  }
}